import { Region } from "../../enums/shared/forms/Region";
import { IUser, LoginState, UserState } from "../../hooks/useAuth";

export const getRegion = (user: UserState): string => {
  const userRegion = (user as IUser)?.region;
  const isLoggedOut = user === LoginState.LoggedOut || user === LoginState.Unknown;
  return !isLoggedOut ? (userRegion ? userRegion : Region.SG) : "";
};
